import $api from "http/index";

const B = "practice/";

export const listOrganizations = () => $api.get(`${B}organizations/`);
export const createOrganization = (data) => $api.post(`${B}organizations/`, data);
export const updateOrganization = (id, data) => $api.patch(`${B}organizations/${id}/`, data);
export const deleteOrganization = (id) => $api.delete(`${B}organizations/${id}/`);

export const listContracts = (params) => $api.get(`${B}contracts/`, { params });
export const createContract = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => { if (v != null) fd.append(k, v); });
  return $api.post(`${B}contracts/`, fd);
};

export const listAssignments = (params) => $api.get(`${B}assignments/`, { params });
export const createAssignment = (data) => $api.post(`${B}assignments/`, data);
export const updateAssignment = (id, data) => $api.patch(`${B}assignments/${id}/`, data);
export const myPractice = () => $api.get(`${B}assignments/my/`);

export const listReports = (params) => $api.get(`${B}reports/`, { params });
export const createReport = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => { if (v != null) fd.append(k, v); });
  return $api.post(`${B}reports/`, fd);
};
export const submitReport = (id) => $api.post(`${B}reports/${id}/submit/`);
export const gradeReport = (id, data) => $api.post(`${B}reports/${id}/grade/`, data);
export const returnReport = (id, data) => $api.post(`${B}reports/${id}/return/`, data);

export const PRACTICE_KINDS = {
  educational: "Учебная", production: "Производственная",
  pre_diploma: "Преддипломная", research: "НИР", pedagogical: "Педагогическая",
};
